import { PRODUCTION_PREVIEW_KEY } from "./localStorage";

const RAW_UI_VERSION = import.meta.env.VITE_UI_VERSION ?? import.meta.env.VITE_APP_VERSION;
export const UI_VERSION = RAW_UI_VERSION ? Number(RAW_UI_VERSION) : 0;

export const IS_TOUCH = "ontouchstart" in self;

export const isWebWorker = Boolean(self.WorkerGlobalScope);

export const APP_VERSION = RAW_UI_VERSION;

export const IS_HOME_SITE = import.meta.env.VITE_IS_HOME_SITE;

export const APP_URL = import.meta.env.VITE_APP_URL;
export const HOME_URL = import.meta.env.VITE_HOME_URL;
export const ENABLE_SIMULATED_MARKET_DATA = import.meta.env.VITE_ENABLE_SIMULATED_MARKET_DATA === "true";

export function isDevelopment() {
  const isProductionPreview = isWebWorker
    ? // @ts-ignore
      Boolean((self as DedicatedWorkerGlobalScope).PRODUCTION_PREVIEW_KEY)
    : Boolean(localStorage.getItem(PRODUCTION_PREVIEW_KEY));

  return !self.location.host?.includes("gmx.io") && !self.location.host?.includes("ipfs.io") && !isProductionPreview;
}

export function isLocal() {
  return self.location.host?.includes("localhost");
}
